/**
 * Mirrors backend/src/config/registration.js
 * Superadmin → FULL_ACCESS_PERMISSIONS
 * Admin → ADMIN_ACCESS_PERMISSIONS
 */

export const FULL_ACCESS_PERMISSIONS = {
  Dashboard_Read: true,
  LiveChat_Read: true,
  LiveChat_Show_All_Intervened: true,
  LiveChat_Transfer_Agent: true,
  LiveChat_TakeOver: true,
  Campaign_Read: true,
  Campaign_Create_CSV_Broadcast_Campaign: true,
  Campaign_Create_Api_Campaign: true,
  Campaign_Create_Broadcast_Campaign: true,
  "Campaign_Create_Whatspp+SMS_Campaign": true,
  Campaign_Schedule_Campaign: true,
  Campaign_SMS_Template: true,
  History_Read: true,
  Contacts_Read: true,
  Contacts_Create: true,
  Contacts_Download: true,
  Contacts_Archive: true,
  ArchivedContacts_Read: true,
  ArchivedContacts_UnArchive: true,
  CannedMessage_Read: true,
  CannedMessage_Create: true,
  CannedMessage_Delete: true,
  CannedMessage_Edit: true,
  CannedMessage_Favourite: true,
  whatsAppTemplate_Read: true,
  whatsAppTemplate_Create: true,
  SmsTemplate_Read: true,
  SmsTemplate_Create: true,
  Template_Lib_Read: true,
  Team_Read: true,
  Team_Create: true,
  Team_Edit: true,
  Team_Delete: true,
  Teamrole_Read: true,
  Teamrole_Create: true,
  Teamrole_Edit: true,
  Teamrole_Delete: true,
  Attribute_Read: true,
  Allprojects_Read: true,
  Profile_Read: true,
  Profile_Change_Password: true,
  Tag_Read: true,
  Tag_Create: true,
  Tag_Edit: true,
  Tag_Delete: true,
  APIKey_Read: true,
  APIKey_Regenerate: true,
  WabaAnalytics_Read: true,
  AgentActivity_Read: true,
  Webhook_Read: true,
  Webhook_Regenerate: true,
  Webhook_Subscribe: true,
  GreetingMessage_Read: true,
  "Opt-inManagement_Read": true,
  Sendtestmessage_Read: true,
  SMSConfig_Read: true,
  Plans_Read: true,
  GoogleSheetIntegration_Read: true,
  GoogleFormConfig_Read: true,
  Dialogflow_Read: true,
  PaymentsSetup_Read: true,
  Payments_Read: true,
};

export const ADMIN_ACCESS_PERMISSIONS = {
  Dashboard_Read: true,
  LiveChat_Read: true,
  LiveChat_Show_All_Intervened: true,
  LiveChat_Transfer_Agent: true,
  LiveChat_TakeOver: true,
  Campaign_Read: true,
  Campaign_Create_CSV_Broadcast_Campaign: true,
  Campaign_Create_Api_Campaign: true,
  Campaign_Create_Broadcast_Campaign: true,
  "Campaign_Create_Whatspp+SMS_Campaign": true,
  Campaign_Schedule_Campaign: true,
  Campaign_SMS_Template: true,
  History_Read: true,
  Contacts_Read: true,
  Contacts_Create: true,
  Contacts_Download: true,
  Contacts_Archive: true,
  ArchivedContacts_Read: true,
  ArchivedContacts_UnArchive: true,
  CannedMessage_Read: true,
  CannedMessage_Create: true,
  CannedMessage_Delete: true,
  CannedMessage_Edit: true,
  CannedMessage_Favourite: true,
  whatsAppTemplate_Read: true,
  whatsAppTemplate_Create: true,
  SmsTemplate_Read: true,
  SmsTemplate_Create: true,
  Template_Lib_Read: true,
  Team_Read: true,
  Team_Create: true,
  Team_Edit: true,
  Team_Delete: true,
  Teamrole_Read: true,
  Teamrole_Create: true,
  Teamrole_Edit: true,
  Teamrole_Delete: true,
  Attribute_Read: true,
  Allprojects_Read: true,
  Profile_Read: true,
  Profile_Change_Password: true,
  Tag_Read: true,
  Tag_Create: true,
  Tag_Edit: true,
  Tag_Delete: true,
  APIKey_Read: true,
  APIKey_Regenerate: true,
  WabaAnalytics_Read: true,
  AgentActivity_Read: true,
  Webhook_Read: true,
  Webhook_Regenerate: true,
  Webhook_Subscribe: true,
  GreetingMessage_Read: true,
  "Opt-inManagement_Read": true,
  Sendtestmessage_Read: true,
  SMSConfig_Read: true,
};

export function getDefaultPermissionsForUserType(userType) {
  const type = String(userType || "")
    .trim()
    .toLowerCase()
    .replace(/[-\s]+/g, "_");
  if (type === "superadmin" || type === "super_admin") {
    return FULL_ACCESS_PERMISSIONS;
  }
  if (type === "admin") {
    return ADMIN_ACCESS_PERMISSIONS;
  }
  return null;
}
